import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {FeatureSummary} from '../../../../../api';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';
import {ElciaButton} from '../../../../components/buttons/button/button';

@Component({
  selector: 'elcia-feature-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableModule, TranslatePipe, ElciaButton],
  templateUrl: './feature-grid.html',
})
export class FeatureGrid {
  features = input.required<FeatureSummary[]>();
  featureSelected = output<FeatureSummary>();
  onDelete = output<FeatureSummary>();

  onRowSelect(feature: FeatureSummary): void {
    this.featureSelected.emit(feature);
  }

  delete(event: Event, feature: FeatureSummary): void {
    event.stopPropagation();
    this.onDelete.emit(feature);
  }
}
